/**
 * HMR-stable module singletons. Replacement for `effect/GlobalValue`, which v4
 * removed with no shipped equivalent: a plain top-level `const` is re-created
 * when Fast Refresh / Vite HMR re-evaluates a module, so parts of the app
 * holding the old instance diverge from new readers. Values are keyed in a
 * process-global map so re-evaluation returns the original instance.
 */
const globalStoreKey = Symbol.for('@listening/utils/globalValue');

const globalStore: Map<unknown, unknown> = (() => {
  const g = globalThis as { [globalStoreKey]?: Map<unknown, unknown> };
  g[globalStoreKey] ??= new Map();
  return g[globalStoreKey];
})();

export const globalValue = <A>(id: unknown, compute: () => A): A => {
  if (!globalStore.has(id)) {
    globalStore.set(id, compute());
  }
  return globalStore.get(id) as A;
};
